module.exports = __webpack_public_path__ + "static/media/logo-dark-fr.cf6baed6.svg";